import React from 'react';
import { DollarSign } from 'lucide-react';
import { useAppContext } from '../../context/AppContext';
import Modal from '../ui/Modal';

const DiscountModal = () => {
  const app = useAppContext();

  return (
    <Modal
      isOpen={app.showDiscountOfferModal}
      onClose={() => app.setShowDiscountOfferModal(false)}
      className="discount-modal"
    >
      <div className="discount-modal__floating-icon">
        <DollarSign size={32} color="white" />
      </div>

      <div className="discount-modal__header">
        <h2 className="discount-modal__title">Wait! Special Offer</h2>
        <p className="discount-modal__subtitle">
          We&rsquo;d hate to see you go. How about a special deal?
        </p>
      </div>

      <div className="discount-modal__body">
        <div className="discount-modal__pricing">
          <div className="discount-modal__old-price">$99/month</div>
          <div className="discount-modal__new-price">$49.50/month</div>
          <div className="discount-modal__savings">Save 50% on your next bill</div>
        </div>

        <div className="confirm-modal__actions">
          <button className="btn btn-primary btn-full" onClick={app.handleAcceptDiscount}>
            Accept 50% Discount
          </button>
          <button className="btn btn-ghost btn-full" onClick={app.handleDeclineDiscount}>
            No thanks, cancel anyway
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default DiscountModal;
